import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { CodeEditorComponent } from './code-editor.component';

@NgModule({
  declarations: [CodeEditorComponent],
  imports: [CommonModule, ReactiveFormsModule, MatProgressSpinnerModule, TranslateModule, MonacoEditorModule],
  exports: [CodeEditorComponent],
})
export class CodeEditorModule {}
